import React, { FC } from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';

interface ProgressBar {
  percent: Number;
}

const cx = classNames.bind(styles);

const ProgressBar = ({ percent }: ProgressBar) => {
  return (
    <div className={cx('progress-outer')}>
      <div className={cx(`progress`)}>
        <div className={cx('progress-bar')} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
